module.exports = __FOREMAN_VENDOR__REACT__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__REACT__"
// module id = react
// module chunks = 0 1 2